
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ContraDetailDialog extends _Ext.EditorDialogBase<ContraDetailRow> {
        protected getFormKey() { return ContraDetailForm.formKey; }
        protected getLocalTextPrefix() { return ContraDetailRow.localTextPrefix; }
        protected getDeletePermission() { return ContraDetailRow.deletePermission; }
        protected getInsertPermission() { return ContraDetailRow.insertPermission; }
        protected getUpdatePermission() { return ContraDetailRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected form = new ContraDetailForm(this.idPrefix);
        public exchangerate;
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.ExchangeRateId);
            
            this.form.LedgerId.changeSelect2(e => {
                if (this.form.LedgerId.value == "1001" ) {
                    this.form.Mode.value = "Cash";
                    q.showAndDisableField(this.form.Mode);
                    q.showAndDisableField(this.form.ChequeDate);
                    q.showAndDisableField(this.form.ChequeNo);
                    q.showAndDisableField(this.form.ChequeDate);
                    q.showAndDisableField(this.form.ChequeNo);
                }
                else {
                    this.form.Mode.value = "Cheque";
                    q.showAndDisableField(this.form.Mode);
                    q.showAndDisableField(this.form.ChequeDate);
                    q.showAndDisableField(this.form.ChequeNo);
                    q.showAndDisableField(this.form.ChequeDate);
                    q.showAndDisableField(this.form.ChequeNo);
                }
            });
            this.form.Amount.changeSelect2(e => {
                var amount = (this.parentEditor.parentDialog as ContraDialog).form.TotalAmount.value;

                if (parseFloat(this.form.Amount.value.toString()) > amount) {

                }
            });
        }
        protected onDialogOpen() {
            //if (Q.Authorization.userDefinition.exchangerate == undefined) {
            //    Q.alert('Please Select Currency');
            //    this.dialogClose();
            //    return;
            //} else {
            //    this.form.ExchangeRateId.value = Q.Authorization.userDefinition.exchangerate;
            //    q.showAndDisableField(this.form.ExchangeRateId);
            //}
            var ledgerid = parseInt((this.parentEditor.parentDialog as ContraDialog).form.LedgerId.value);
            if (ledgerid == 0 || ledgerid == null) {
                Q.alert('Please Select Party');
                Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
                this.dialogClose();
                return;
            }
            //if (ContraDetailDialog.lock) {
            //    this.element.find('.tool-buttons').attr("style", "display:none;");
            //    this.element.find('.s-DialogToolbar').attr("style", "display:none;");
            //    this.element.find('.s-Toolbar').attr("style", "display:none;");
            //    this.element.find('.clearfix').attr("style", "display:none;");
            //    q.showAndDisableField(this.form.Mode);
            //    q.showAndDisableField(this.form.ChequeDate);
            //    q.showAndDisableField(this.form.ChequeNo);
            //    q.showAndDisableField(this.form.Amount);
            //    q.showAndDisableField(this.form.LedgerId);
            //}
        }
        
        
    }
}